import React from 'react'
import styled from 'styled-components'

const StyledPageHeader = styled.section`
  > header {
    background-color: ${({ theme }) => theme.colors.darkBlue};
    min-height: 688px;
    padding: 120px 24px 48px;
    position: relative;
    width: 100%;

    ${({ theme }) => theme.media.desktop} {
      padding-top: 176px;
    }

    sub {
      color: #8a94a6;
    }

    h1,
    h3 {
      color: #fff;
    }

    h4 {
      color: #8a94a6;
    }

    p {
      color: #fff;

      strong {
        color: #fff;
        font-weight: 500;
      }
    }
  }

  > header {
    width: 100%;
  }

  /* pricing */
  > main {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.greyBG};
    display: flex;
    flex-direction: column;
    margin-top: -260px;
    padding: 62px 20px 0;
    width: 100%;

    ${({ theme }) => theme.media.desktop} {
      margin-top: -300px;
    }
  }

  > main > section {
    padding: 14px 46px 0px;
    width: 100%;
  }

  /* pricing eu */
  > section {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.greyBG};
    display: flex;
    flex-direction: column;
    margin-top: -140px;
    padding: 62px 20px 0;
    width: 100%;

    ${({ theme }) => theme.media.desktop} {
      margin-top: -260px;
    }
  }
`

const ExtendedPageHeader = ({ children }) => {
	return <StyledPageHeader>{children}</StyledPageHeader>
}

export default ExtendedPageHeader